import { useRequest } from 'ahooks'

import { getAggregateStagesInstance } from '..'
import { AggregatedStagesDTO } from '../../../data/@types/dtos'
import { MetricParams } from 'plugin-product-frac-ui/shared/registries/metrics-registry'

interface AggregatedStagesRequest {
    crewIds: string[]
    begin: number
    end: number
}

interface UseGetAggregatedStagesParams {
    params?: MetricParams
    lookbackDays?: number
}

interface Response {
    data?: AggregatedStagesDTO
    error?: Error | null
    loading: boolean
}

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000

const buildRequestPayload = (params: MetricParams | undefined, lookbackDays: number): AggregatedStagesRequest => {
    const end = Date.now()
    const begin = end - lookbackDays * ONE_DAY_IN_MS

    if (!params) {
        return {
            crewIds: [],
            begin,
            end
        }
    }

    const requestIds = params.selectedViewType === 'job' ? params.selectedJobIds ?? [] : params.selectedCrewIds ?? []

    return {
        crewIds: requestIds,
        begin,
        end
    }
}

async function getAggregatedStages({ params, lookbackDays = 1 }: UseGetAggregatedStagesParams = {}): Promise<
    AggregatedStagesDTO
> {
    const viewType = params?.selectedViewType || 'crew'
    const instance = getAggregateStagesInstance(viewType)
    const payload = buildRequestPayload(params, lookbackDays)

    try {
        const response = await instance.post<AggregatedStagesDTO>('', payload)
        return response.data
    } catch (error) {
        console.error('[getAggregatedStages] ERROR - Failed to fetch aggregated stages:', error)
        throw error
    }
}

const useGetAggregatedStages = (options?: UseGetAggregatedStagesParams): Response => {
    return useRequest(() => getAggregatedStages(options), {
        refreshDeps: [options?.params, options?.lookbackDays]
    })
}

export default useGetAggregatedStages
